import { computed } from 'vue';
import { useStore } from '@/store';
export const useLinkedinTemplateVariables = () => {
  const store = useStore();
  const variables = computed(() => store.state.emails.templatesVariables);

  const filteredVariables = computed(() => variables.value.filter((variable: any) => {
    return variable.source === 'coder';
  }));

  const formattedVariablesForPreview = computed(() => {
    return filteredVariables.value.map((variable: any) => ({
      label: variable.name,
      name: variable.name,
      value: variable.value,
    }));
  });

  return {
    linkedinTemplateVariables: formattedVariablesForPreview,
  };
};
